<div class="asset-details-columns flex w-full h-full">
  <div class="asset-details-main-column widget-bg-color rounded-lg grow item w-full p-4">
    <!-- Asset view -->
    <thehubz-asset-view [data]="assetInfo"></thehubz-asset-view>
  </div>
  <div class="asset-details-aside-column widget-bg-color rounded-lg item grow-0 w-2/4 overflow-y-auto">
    <!-- Metadata view -->
    <thehubz-asset-tagging-n-taxonomy-metadata
      class="flex h-full flex-col justify-between"
      *ngIf="assetInfo"
      [sharingFlag]="sharingFlag"
      [assetInfo]="assetInfo"
    ></thehubz-asset-tagging-n-taxonomy-metadata>
  </div>
</div>
